

function shorten(str, maxLen) {
  if (str.length <= maxLen) return str;
  return str.substr(0, str.lastIndexOf(' ', maxLen) ) + '...';
}




function stripHtml(html) 	{
   let tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}



function placeCaretAtEnd(el) {
    el.focus();
    if (typeof window.getSelection != "undefined"
            && typeof document.createRange != "undefined") {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        el.innerHTML.trimEnd();
    } else if (typeof document.body.createTextRange != "undefined") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
    }
}




function isUrlImage(url) {
	// https://stackoverflow.com/questions/9714525/javascript-image-url-verify
	var reg_test = /\.(jpeg|jpg|gif|png|tiff|bmp)$/;
	return (url.match(reg_test) != null);
}

function fileNameFromImageUrl(url) {
   var matches = url.match(/\/([^\/?#]+)[^\/]*$/);
   if (matches.length > 1) {
     return matches[1];
   }
   return null;
}

function downloadFile(url) {
   	var image = new Image();
	image.src = url;
	image.onload = function(){
          log('image', image)
      }
}




function ParsedUrl(url) {
    var parser = document.createElement("a");
    
    parser.href = url;
    
    // IE 8 and 9 dont load the attributes "protocol" and "host" in case the source URL
    // is just a pathname, that is, "/example" and not "http://www.example.com/example".
    parser.href = parser.href;
    
    // IE 7 and 6 wont load "protocol" and "host" even with the above workaround,
    // so we take the protocol/host from window.location and place them manually
    if (parser.host === "") {
        var newProtocolAndHost = window.location.protocol + "//" + window.location.host;
        if (url.charAt(1) === "/") {
            parser.href = newProtocolAndHost + url;
        } else {
            // the regex gets everything up to the last "/"
            // /path/takesEverythingUpToAndIncludingTheLastForwardSlash/thisIsIgnored
            // "/" is inserted before because IE takes it of from pathname
            var currentFolder = ("/"+parser.pathname).match(/.*\//)[0];
            parser.href = newProtocolAndHost + currentFolder + url;
        }
    }

    
    // copies all the properties to this object
    var properties = ['host', 'hostname', 'hash', 'href', 'port', 'protocol', 'search'];
    for (var i = 0, n = properties.length; i < n; i++) {
      this[properties[i]] = parser[properties[i]];
    }

    // check if is an image
    if(isUrlImage(url)) {
    	this.is_image = true;
    	this.image_name = fileNameFromImageUrl(url);
    } else {
    	this.is_image = false;
    }
    downloadFile(url)
    
    // pathname is special because IE takes the "/" of the starting of pathname
    this.pathname = (parser.pathname.charAt(0) !== "/" ? "/" : "") + parser.pathname;
  
  	//search Params
  	this.searchParam =  function(variable) {
    	var query = (this.search.indexOf('?') === 0) ? this.search.substr(1) : this.search;
    	var vars = query.split('&');
	    for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split('=');
	        if (decodeURIComponent(pair[0]) == variable) {
	            return decodeURIComponent(pair[1]);
	        }
	    }
	    console.log('Query variable %s not found', variable);
	    return '';
    };
}








                          Date.prototype.addHours = function(h) {
                            this.setTime(this.getTime() + (h*60*60*1000));
                            return this;
                          }

















// https://stackoverflow.com/questions/11890664/how-can-i-strip-certain-html-tags-out-of-a-string




    // "Remove all tags from element `el' that aren't in the ALLOWED_TAGS list."
	function sanitize(el) {
		var ALLOWED_TAGS = ["B", "U", "I"];
	    var tags = Array.prototype.slice.apply(el.getElementsByTagName("*"), [0]);
	    for (var i = 0; i < tags.length; i++) {
	        if (ALLOWED_TAGS.indexOf(tags[i].nodeName) == -1) {
	            usurp(tags[i]);
	        } else {
	        	tags[i].removeAttribute("style")
	        } 
	    }
	}
	// "Replace parent `p' with its children.";
	function usurp(p) {
	    var last = p;
	    for (var i = p.childNodes.length - 1; i >= 0; i--) {
	        var e = p.removeChild(p.childNodes[i]);
	        p.parentNode.insertBefore(e, last);
	        last = e;
	    }
	    p.parentNode.removeChild(p);
	}
	function sanitizeString(string) {
	    var div = document.createElement("div");
	    div.innerHTML = string;
	    sanitize(div);
	    return div.innerHTML;
	}




















// FIT TEXT --------------------
	

	function scaleHeader() {
	  var scalable = document.querySelectorAll('.fitText');
	  var margin = 10;
	  for (var i = 0; i < scalable.length; i++) {
	    var scalableContainer = scalable[i].parentNode;
	    scalable[i].style.transform = 'scale(1)';
	    var scalableContainerWidth = scalableContainer.offsetWidth - margin;
	    var scalableWidth = scalable[i].offsetWidth;
	    scalable[i].style.transform = 'scale(' + scalableContainerWidth / scalableWidth + ')';
	    scalableContainer.style.height = scalable[i].getBoundingClientRect().height + 'px';
	  }
	} 


	// Debounce by David Walsch
	// https://davidwalsh.name/javascript-debounce-function

	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	var myScaleFunction = debounce(function() {
		scaleHeader();
	}, 250);

	// myScaleFunction();

	// $(window).on('resize', myScaleFunction);



